import '../styles/universityHome.scss';
import university  from '../assets/university.png';

export const UniversityHome = () => {
  return (
    <div className='university-home'>
    <div className='university-home-container'>
        <div className='uh-photo' data-aos="zoom-in" data-aos-delay="200" data-aos-duration="800" data-aos-easing="ease-out">
            <img src={university} alt="Logo" />
        </div>
        <div className='uh-text'>
            <h2 data-aos="fade-right" data-aos-delay="300" data-aos-duration="900" data-aos-easing="ease-out">
                Desarrolla tu potencial con<br /> Serendipia University
            </h2>
            <p data-aos="fade-right" data-aos-delay="400" data-aos-duration="1000" data-aos-easing="ease-out">
                Impulsá tu carrera con nuestros <span>cursos especializados</span> en habilidades clave para el éxito profesional.<br />
                En University, conectamos la formación con las demandas del mercado laboral para <span>llevar tu perfil al siguiente nivel.</span>
            </p>
            <a data-aos="fade-right" data-aos-delay="500" data-aos-duration="1100" data-aos-easing="ease-out" href="https://serendipiauniversity.com/" className='button' target='_blank' rel="noreferrer">
                Conocé nuestros programas
            </a>
        </div>
    </div>
</div>

  )
}
